import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;

  @media only screen and (min-width: ${(props: any) => props.theme.breakpoints.values.sm}px) {
    flex-wrap: nowrap;
  }

  &:not(:last-of-type) {
    margin-bottom: 1em;
  }
`;

export default Row;
